<template>
  <div>
    <div class="catalog-view__head">
      <ul class="catalog-view__breadcrumbs">
        <li><a href="/">Каталог</a></li>
        <li v-html="product.description"/>
      </ul>
      <div class="catalog-view__caption" v-if="product.activity">Активити: {{ product.activity.name }}
        <span v-if="product.activity.description">— {{ product.activity.description }}</span>
      </div>
      <div class="catalog-view__top-vendor catalog-view__top-vendor-mobile">{{ product.reference }}</div>
      <div class="catalog-view__top-row">
        <div class="catalog-view__top-vendor">{{ product.reference }}</div>
        <div class="catalog-view__top-actions">
          <a class="catalog-view__link catalog-view__link--lg"
             :href="'#analogs'" v-if="product.hasAnalog">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 13H6V11H4V13ZM4 18H6V16H4V18ZM4 8H6V6H4V8ZM8 13H20V11H8V13ZM8 18H20V16H8V18ZM8 6V8H20V6H8Z" fill="#00AC86"/>
            </svg>
            <span>Есть аналоги</span>
          </a>
          <a class="catalog-view__link catalog-view__link--lg"
             :href="'/sale/ad?AdSearch[reference]=' + product.reference" v-if="product.inSale">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86"/>
              <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2"/>
            </svg>
            <span>Этот референс есть в Распродажах</span>
          </a>
          <div>
            <a class="catalog-view__link catalog-view__link--lg" @click="copyLink()">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="6" y="10" width="8" height="8" rx="1" stroke="#00AC86" stroke-width="2"/>
                <path
                    d="M14 14H17C17.5523 14 18 13.5523 18 13V7C18 6.44772 17.5523 6 17 6H11C10.4477 6 10 6.44772 10 7V10"
                    stroke="#00AC86" stroke-width="2"/>
              </svg>
              <span content="Ссылка скопирована" v-tippy="{ arrow : false,  trigger: 'click', interactive : true }">Копировать ссылку на референс</span>
            </a>
          </div>
          <a class="catalog-view__link catalog-view__link--lg" @click="createPdf()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                 v-if="!isPdfCreate">
              <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2"/>
              <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
                    stroke-width="2" stroke-linecap="square"/>
              <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2"/>
            </svg>
            <img class="preloader" v-if="isPdfCreate" src="/img/preloader.svg" alt="" width="24" height="24">
            <span>Скачать всю информацию в PDF</span>
          </a>
        </div>
      </div>
      <h1 class="catalog-view__title" v-html="product.description"/>
      <div class="catalog-view__status catalog-view__status-mobile" v-if="product.isReplaced">Продажи прекращены</div>
    </div>
    <div class="catalog-view__inner">
      <div class="catalog-view__left">
        <a v-if="product.photoUrl" class="catalog-view__link catalog-view__link--lg" :href="product.photoUrl">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86"></path>
            <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2"></path>
          </svg>
          <span>Редактировать</span>
        </a>
        <ul class="catalog-view__tabs" v-if="product.photos360.length">
          <li :class="activeTab === 'images' ? 'is-active' : ''" @click="setActiveTab('images')"
              v-if="product.images.length">Фото
          </li>
          <li :class="activeTab === '360' ? 'is-active' : ''" @click="showModal()">360°</li>
        </ul>
        <div class="catalog-view__img">
          <img v-if="mainImage" :src="mainImage.url" width="312" alt="">
          <img v-if="!mainImage" src="/img/no-photo.png" alt="">
        </div>
        <ul class="catalog-view__thumbs" v-if="product.images.length">
          <li @click="setImage(image)" :class="mainImage && mainImage.url === image.url ? 'is-active' : ''"
              v-for="(image, key) in product.images" :key="key">
            <img :src="image.url" width="40" height="40" alt="">
          </li>
        </ul>
        <a v-if="product.images.length" class="catalog-view__link catalog-view__link--lg" @click="createImageFile()" style="margin-top: 20px">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
               v-if="!isImageCreated">
            <path d="M5 15L5 18H19V15" stroke="#00AC86" stroke-width="2"/>
            <path d="M15 11L12.0707 13.9293C12.0317 13.9683 11.9683 13.9683 11.9293 13.9293L9 11" stroke="#00AC86"
                  stroke-width="2" stroke-linecap="square"/>
            <line x1="12" y1="14" x2="12" y2="5" stroke="#00AC86" stroke-width="2"/>
          </svg>
          <img class="preloader" v-if="isImageCreated" src="/img/preloader.svg" alt="" width="24" height="24">
          <span>Скачать все фото</span>
        </a>
      </div>
      <div class="catalog-view__right">
        <div class="catalog-view__status" v-if="product.closeDate && !product.closeDate.inFuture">Снято с производства</div>
        <div class="catalog-view__status" v-if="product.closeDate && product.closeDate.inFuture">Плановое снятие с производства {{product.closeDate.date}}</div>
        <replacement-reference :references="product.replacementReferences" v-if="product.isReplaced"/>
        <a class="catalog-view__link catalog-view__link-mobile" href="#" v-if="product.rates.length">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86"/>
            <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2"/>
          </svg>
          <span>Все тарифы</span>
        </a>
        <div class="catalog-view__table-chars">
          <table>
            <tbody>
            <tr v-if="product.rates.length">
              <th>Тариф</th>
              <td>
                <div class="catalog-view__table-row">
                  <div> {{ getRates(product.rates) }}</div>
                  <!--<a class="catalog-view__link" href="#">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 15L18 6L9 6L9 8L16 8L16 15L18 15Z" fill="#00AC86" />
                      <path d="M17 7L6 18" stroke="#00AC86" stroke-width="2" />
                    </svg>
                    <span>Все тарифы</span>
                  </a>-->
                </div>
              </td>
            </tr>
            <tr v-if="product.countries.length">
              <th>Страна</th>
              <td> {{ product.countries.join(', ') }}</td>
            </tr>
            <tr v-if="product.brand">
              <th>Бренд</th>
              <td>{{ product.brand }}</td>
            </tr>
            <tr>
              <td colspan="2" v-if="product.brand || product.countries.length || product.rates.length">
                <hr class="catalog-view__table-divider">
              </td>
            </tr>
            <tr v-if="product.description">
              <th>Описание</th>
              <td v-html="product.description"/>
            </tr>
            <tr v-if="product.fullDescription">
              <th>Доп. описание</th>
              <td v-html="product.fullDescription"/>
            </tr>
            <tr v-if="product.keywords.length && false">
              <th>Ключевые слова</th>
              <td>
                {{ product.keywords.join(', ') }}
              </td>
            </tr>
            <tr v-if="product.description">
              <td colspan="2">
                <hr class="catalog-view__table-divider">
              </td>
            </tr>
            <tr v-if="product.lines.length">
              <th>Линейки</th>
              <td> {{ product.lines.join(', ') }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <product-video :product_id="product.id"/>

    <product-stock :product_id="product.id"/>

    <photo-360-modal v-if="product.photos360.length" :reference="product.reference"/>

  </div>
</template>

<script>
import ReplacementReference from "./ReplacementReference";
import ProductVideo from "./ProductVideo";
import ProductStock from "./ProductStock";
import Photo360Modal from "./Photo360Modal";

export default {
  name: 'product',
  components: {
    Photo360Modal,
    ProductVideo,
    ProductStock,
    ReplacementReference
  },
  props: {
    product: {
      type: Object,
      require: true
    }
  },
  data: () => ({
    mainImage: null,
    activeTab: 'images',
    isPdfCreate: false,
    isImageCreated: false
  }),
  created() {
    if (this.product.images.length) {
      this.mainImage = this.product.images[0]
    }
  },
  mounted() {
    this.$root.$on('photo-360-modal::hide', () => {
      this.activeTab = 'images'
    })
  },
  methods: {
    getRates(rates) {
      return rates.join(', ')
    },
    setImage(image) {
      this.mainImage = image;
    },
    showModal() {
      this.activeTab = '360'
      this.$root.$emit('photo-360-modal::show')
    },
    setActiveTab(tab) {
      this.activeTab = tab
    },
    createImageFile() {
      this.isImageCreated = true
      this.$root.$emit('create-image-file::fire')
    },
    createPdf() {
      this.isPdfCreate = true
      this.$root.$emit('create-pdf::fire')
    },
    pdfFinished() {
      this.isPdfCreate = false
    },
    imageFinished() {
      this.isImageCreated = false
    },
    copyLink() {
      const copyText = process.env.VUE_APP_API_URL + '/catalog/view/' + this.product.reference
      const textArea = document.createElement('textarea')
      textArea.textContent = copyText
      document.body.append(textArea)
      textArea.select()
      document.execCommand('copy')
      textArea.remove()
      setTimeout(function () {
        const tippy = document.getElementsByClassName('tippy-popper')
        if (tippy.length) {
          tippy[0].remove()
        }
      }.bind(this), 800);
    }
  }
}
</script>